module.exports = __webpack_public_path__ + "media/customizations/mywilloway/chat-bubble-2a3f279130880508122422fd5cf2c497.png";